import React,{useContext} from 'react'
import {Box,Stack,Typography} from '@mui/material'

import BodyPart from './BodyPart'

const HorizontalScrollBar = ({data,bodyPart,setBodyPart}) => {
  return (
     <Box display="flex" justifyContent="space-around" flexWrap="wrap">
        {data.map((item) => (
            <Box
              key={item}
              itemId={item}
              title={item}
              m="5px 2px"
            >
             <BodyPart item={item} bodyPart={bodyPart} setBodyPart={setBodyPart}/>
            </Box>
        ))} 
    </Box>
  )
}

export default HorizontalScrollBar